module.exports = __webpack_public_path__ + "img/ep3-8.1b2539f9.jpg";